<template>
  <div class="agreement-contain">
    <div>
      <p style="margin-top:0pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          一部手机管旅游隐私政策
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          更新日期：
        </span>
        <span style="font-family:'微软雅黑'">
          2026年4月24日
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          生效日期：
        </span>
        <span style="font-family:'微软雅黑'">
          2026年4月30日
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          版本更新提示
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          欢迎您使用一部手机管旅游！
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为保障您的权益，我们于近期更新了《一部手机管旅游隐私政策》，请您关注本次更新的主要内容：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.补充了隐私政策摘要，完善了未成年人专项保护规则、个人敏感信息收集必要性等相关内容，方便您迅速了解本隐私政策内容及更新情况。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.更新<router-link :to="{ path: '/thirdShare' }">《一部手机管旅游APP第三方信息共享清单》</router-link>，方便您清晰地了解信息共享情况。
        </span>
        
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          概览
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          一部手机管旅游由云南腾云信息产业有限公司（注册地为云南省昆明市西山区环城南路777号昆钢科技大厦6F）提供服务。
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          为说明一部手机管旅游会如何收集、使用和存储您的个人信息及您享有何种权利，我们将通过《一部手机管旅游隐私政策》向您阐述要点如下：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.我们将逐一说明我们收集的您的个人信息类型及其对应的用途，以便您了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.当您使用某些功能时，我们会在获得您的同意后，收集您的敏感个人信息。除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使您无法使用相关特定功能，但不影响您正常使用一部手机管旅游的其他功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.除经过您同意的本《一部手机管旅游隐私政策》明确说明的情形以外，我们不会主动共享或转让您的个人信息至第三方。如存在其他共享或转让您的个人信息，或您需要我们将您的个人信息共享或转让至第三方时，我们会直接征得或确认第三方征得您对上述行为的明示同意，但法律法规另有规定或因保护用户权益需要除外。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.我们不会主动从第三方获取您的个人信息。如为业务发展需要从第三方获取您的个人信息，我们会依法核实来源的合法性，或在获取前取得您的明示同意，如增加新功能需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的个人信息前，征得您的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          5.您可以通过《一部手机管旅游隐私政策》所列途径及方式查阅、更正、复制、删除您的个人信息，也可以撤回同意、注销账号、投诉举报以及设置权限等隐私功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.为了在《一部手机管旅游隐私政策》所述范围内收集您的信息，或者向您提供服务、优化我们的服务以及保障您的账号安全，我们将需要向您索取相关的权限；其中的敏感权限均不会默认开启，只有在您明确同意后我们才会在您同意的范围内调用或使用。对您已经向我们授权的权限，您也可以在“一部手机管旅游APP-我的-设置-系统权限管理”中查询我们已调用或使用的系统权限类型、使用目的，并进行统一管理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          需要特别说明的是，我们获得具体某一项敏感权限并不代表我们必然会收集您的相关信息；即使我们已经获得敏感权限，也仅在必要范围内，并在您使用相关的服务或功能期间根据本指引来收集您的相关信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          正文
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          隐私权是用户的重要权利，云南腾云信息产业有限公司（下称“我们”）非常重视用户（“用户”是指注册、登录、使用、浏览本服务的个人或组织，也称“您”）个人信息和隐私的保护，我们深知个人信息对您的重要性，特制定《一部手机管旅游隐私政策》（下称“本政策”），我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在使用“一部手机管旅游”App或PC端（下称“一部手机管旅游平台”）前，请您务必仔细阅读并透彻理解，我们希望通过本隐私政策向您说明我们在您使用“一部手机管旅游平台”的产品与服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          特别提示
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为了更好保护您的个人信息，请在使用“一部手机管旅游平台”的产品与服务前，仔细阅读并充分了解本政策。重点内容我们已采用粗体特别提示，希望您在阅读浏览时特别关注。
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          一旦您使用或继续使用一部手机管旅游产品与服务，即表示您同意我们按照本政策处理您的相关信息。同时，对我们所收集的您的敏感信息，我们已用粗体的方式进行了标示，以此向您增强式提示。一旦您同意提供您的个人敏感信息，我们将按本政策所述的目的和方式处理您的个人敏感信息。
        </span>
        <span style="font-family:'微软雅黑'">
          我们使用您的个人敏感信息的目的是实现一部手机管旅游的产品与服务相关的功能。您有权拒绝向我们提供个人敏感信息，但是拒绝我们收集使用这些信息可能会影响您使用相关功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          第一部分 定义
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，具体参照GB/T35273-2020。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          个人敏感信息：
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致名誉、身心健康受损的个人信息
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          。
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          本平台涉及：个人生物识别信息、个人财产信息、个人健康生理信息、个人身份信息、其他信息（住宿信息、精准定位信息、网页浏览记录等）
        </span>
        <span style="font-family:'微软雅黑'; text-decoration:underline">
          、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          14岁以下（含）儿童信息等的个人信息
        </span>
        <span style="font-family:'微软雅黑'">
          （我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          第二部分 隐私政策
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          一、政策目录
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （一）我们如何收集和使用您的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （二）我们如何使用Cookie
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （三）我们如何共享、转让、公开披露个人信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （四）我们如何保护个人信息安全
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （五）您如何管理您的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （六）我们如何处理未成年人的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （七）“双清单”展示说明
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （八）从中国大陆地区以外访问一部手机管旅游平台
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （九）本政策如何更新
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          （十）如何联系我们
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          二、政策内容
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （一）我们如何收集和使用您的个人信息
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.收集使用原则
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.1合法、正当、必要、诚信，仅为实现产品与服务之明确、合理目的；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.2逐项列明收集信息，不使用“等、包括但不限于、其他目的”等模糊表述；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.3权限申请与功能场景绑定，拒绝非必要权限不影响基础功能使用；
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4敏感信息单独告知、单独同意，法律法规规定除外。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.在您使用我们的产品及服务时，我们可能需要收集和使用您的个人信息包括如下两种：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          2.1为实现向您提供我们产品及服务的基本功能，您须授权我们收集、使用必要的信息。若您拒绝提供相应信息，您将无法正常使用我们的产品及服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          2.2为实现向您提供我们产品及服务的附加功能，您可选择授权我们收集、使用的信息。若您拒绝提供，您将无法正常使用相应的附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及服务的基本功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.我们会为实现本政策下述的各项功能，收集和使用您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.1成为我们的用户
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          本平台不向公众开放自主注册，仅面向旅游监管工作人员、涉旅企业（旅行社、导游）等内部用户，由客服/管理后台开通账号。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.1.1
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          您申请成为一部手机管旅游平台管理部门用户时
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          需要通过文末方式联系客服为您开通账号，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          您需要通过客服至少向我们提供您本人的姓名、手机号码，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          若您不提供这类信息，您将无法成为一部手机管旅游平台管理部门用户。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          您可自主选择是否向我们提供
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          身份证号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.1.2
        </span>
        <span style="font-family:'微软雅黑'">
          您申请成为一部手机管旅游平台旅行社用户时，
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          您需要至少向我们提供姓名、手机号码
        </span>
        <span style="font-family:'微软雅黑'">
          ，若您不提供这类信息，您将无法成为一部手机管旅游平台旅行社用户。
        </span>
        <span style="font-family:'微软雅黑'">
          在上述信息经您所在地区的主管机构审核通过后，
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          您需要至少向我们提供旅行社及法定代表人基本信息、所属区域、您的邮箱、传真信息并完成入库流程，
        </span>
        <span style="font-family:'微软雅黑'">
          若您不提供这类信息，您将无法使用一部手机管旅游平台旅行社管理功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.1.3您申请成为一部手机管旅游平台导游用户时，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          您需要至少向我们提供姓名、手机号码、导游证号、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          身份证号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，若您不提供这类信息，您将无法成为一部手机管旅游平台导游用户。在上述信息经您所在地区的主管机构审核通过后，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          您需要至少向我们提供性别、出生日期、身份证有效期、语种、学历、民族、专业、毕业院校、资格证发证日期、发证机关、导游证发证日期、导游所在机构、导游证发证地区、导游星级、导游等级、领队类型、导游证有效期、特长、合同到期时间信息
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          并完成入库流程，若您不提供这类信息，您将无法使用一部手机管旅游平台导游管理功能。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在您成为我们的用户后，若您使用本人手机号码登录，我们将通过发送短信验证码的方式来验证您的身份是否有效。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.2基础服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.1提供投诉管理功能：在您浏览一部手机管旅游平台的过程中，您可以对游客发起的投诉进行处置，包含投诉件录入、上报、转办、分发、处置反馈、办结反馈。为确保投诉能够有效处置，您使用投诉单录入功能时，您至少需录入：
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          游客姓名、游客手机号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          游客出行方式为团队游时，您需录入
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          游客身份证号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          便于核实游客抱团信息，提升投诉处置效率
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，若您不提供这类信息，您将无法使用一部手机管旅游平台投诉单录入功能。同时，您可以对投诉件进行督办、关注，确保投诉件按要求进行处置。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障投诉处置流程的完整性和可追溯性，并帮助我们优化服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.2提供退货处置功能：在您浏览一部手机管旅游平台的过程中，您可以对游客发生的退货进行处置，包含退货单录入、上报、转办、地址反馈、办结反馈，为了确保退货能够有效处置，您使用退货单录入功能时您至少需自主录入：
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          游客姓名、游客手机号、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          游客身份证号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，同时通过
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          短信验证码
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          的方式对
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          游客手机号
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          进行验证，若您不提供这类信息，您将无法使用一部手机管旅游平台退货单录入功能。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          您可以对退货单进行督办、关注，确保退货单按要求进行处置。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录、
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障退货处置流程的完整性和可追溯性，并帮助我们优化服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.3提供诚信评价管理功能：在您浏览一部手机管旅游平台的过程中，您可以查询涉旅诚信企业相关数据，并对涉旅诚信企业进行监管。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对涉旅企业诚信状况查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.4提供旅行社管理功能：在您浏览一部手机管旅游平台的过程中，您可以查询旅行社相关数据，包含：旅行社基础信息、旅行社从业人员信息、旅行社出散团情况，并对旅行社进行监管。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对旅行社信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.5提供导游管理功能：在您浏览一部手机管旅游平台的过程中，您可以查询导游相关数据，包含：导游基础信息、导游执业信息情况，并对导游进行监管。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对导游信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.6提供团队监管功能：在您浏览一部手机管旅游平台的过程中，您可以查询团队监管相关数据，包括参团游客、带团导游、电子行车单、综合预警、游客评价等数据，并录入购物店信息，对团队信息进行监管。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          在您使用“购物店标记”功能时，您需开启手机
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置权限
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          ，我们会收集您的个人常用设备信息，用于向您提供购物店标记服务，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          若您不开启位置权限，您将无法使用一部手机管旅游平台购物店标记功能。在您使用上述功能的过程中，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置的记录、个人信息主体操作记录，包括浏览记录、软件使用记录、点击记录、收藏列表、搜索记录在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对旅游团队信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.7提供景区预约查询功能：在您浏览一部手机管旅游平台的过程中，您可以查询景区预约数据。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对景区预约信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.8提供文旅项目管理功能：在您浏览一部手机管旅游平台的过程中，您可以查询云南文旅项目相关数据，包括：文旅项目信息、投资方信息、对外招商信息、招商活动信息、留言信息，并对项目信息进行审核，对留言信息进行处理。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对文旅项目信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          3.2.9提供考核管理功能：在您浏览一部手机管旅游平台的过程中，您可以查询云南省16州市考核数据，包括：各州市各季度考核分数、得分排名，以及各州市考核项目扣分明细。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          我们会收集包括您的浏览及处置记录、个人信息主体操作记录，包括
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          浏览记录、软件使用记录、点击记录、收藏列表在内的服务日志信息，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          这些信息用于保障您对16州市考核信息查询与监管操作可追溯，帮助我们优化功能体验与服务质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.2.10提供个人账号管理功能：您需通过
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          手机号、密码
        </span>
        <span style="font-family:'微软雅黑'">
          或通过
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          手机号、短信验证码
        </span>
        <span style="font-family:'微软雅黑'">
          登录后才能使用一部手机管旅游平台，如您忘记登录密码，您可以通过
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          手机号、短信验证码
        </span>
        <span style="font-family:'微软雅黑'">
          重新设置
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          新密码
        </span>
        <span style="font-family:'微软雅黑'">
          后登录系统。在您浏览一部手机管旅游平台的过程中，您可以对您的个人账号信息进行管理，您换绑手机号时，我们会收集您
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          原绑定手机号的短信验证码、换绑手机号、换绑手机号的短信验证码、新密码
        </span>
        <span style="font-family:'微软雅黑'">
          用于实现换绑手机号功能。您修改登录密码时，我们会收集您的
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          手机号、短信验证码、新密码
        </span>
        <span style="font-family:'微软雅黑'">
          用于实现修改密码功能。您注销账号时，我们会收集
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          您的手机号、短信验证码
        </span>
        <span style="font-family:'微软雅黑'">
          用于实现注销功能。若您不提供这类信息，您将无法使用一部手机管旅游平台账号管理功能，包括登录、重置密码、换绑手机号、注销账号。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.3剪贴板读写说明
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          当您在一部手机管旅游平台使用复制和粘贴信息时，
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          我们将把您需要复制和粘贴的信息写入剪贴板
        </span>
        <span style="font-family:'微软雅黑'">
          ，以便帮助您快捷地实现复制粘贴的功能。上述场景下我们不会留存您剪贴板里的任何内容；同时，我们也不会未经您事先授权使用您的剪贴板或剪贴板里的内容。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.4消息通知说明
        </span>
      </p>
      <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们使用消息推送类SDK（移动推送TPNS
          SDK、华为推送SDK）为您提供消息推送功能。当您有新的消息通知时，一部手机管旅游App将自行启动，以便在您未主动启动App的情况下能及时接收消息。如您不希望一部手机管旅游App自启动，可通过手机设置关闭一部手机管旅游消息通知，系统向您发送消息时将不会导致一部手机管旅游App自启动，在您主动启动一部手机管旅游App前也不再为您推送消息通知。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.5个性化推荐说明
        </span>
      </p>
      <p style="margin-top:3pt; margin-bottom:3pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在您使用一部手机管旅游平台的过程中，我们不会应用您的个人信息对您提供个性化推荐服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.6提供安全保障
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为保障您使用本平台产品与服务时的账号安全与系统运行安全，提升服务安全性与可靠性，防范危害用户、平台及公共利益的行为，我们会收集并处理您的相关信息，用于风险识别、身份验证、安全检测、事件处置、故障排查及服务优化
        </span>
        <span style="font-family:'微软雅黑'">
          。
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt">
          我们仅在实现安全保障目的所必需的最小范围内收集以下信息
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          ：个人常用设备信息（包括设备型号、硬件序列号、设备名称、设备MAC地址、网络类型/网络状态、操作系统类型、产品版本号、服务故障信息、应用安装列表、应用程序信息（GET
          TASK检索）、唯一设备识别码（IMEI/Android ID/IDFA/UUID/GUID、IMSI信息）、登录IP地址、包括您授权的
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          GPS位置
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          以及WLAN接入点和基站的传感器信息）、手机状态，以及个人信息：姓名、手机号、密码，
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          我们将基于上述信息开展账号风险判定、身份核验、客户服务、安全事件检测与防范、数据存档与备份等工作，并依法采取记录、审计、分析、处置等必要措施。当检测到账号存在安全风险时，我们将使用相关信息开展安全验证与风险处置，保障您的合法权益；当发生账号或系统安全问题时，相关信息将用于服务优化与故障修复。
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您在激活使用本平台时，腾讯 TBS 浏览服务会收集以下信息，用于保障页面正常浏览与安全加载：
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备信息（Android
          ID、设备型号、系统版本、品牌、CPU架构、名称、IDFV、设备系统构建信息），应用信息（应用包名、应用版本号、运行状态），网络类型（3G、4G、5G、WiFi），访问网络信息(IP地址)，访问WiFi网络信息(WiFi状态)
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          ，
        </span>
        <span style="font-family:'微软雅黑'">
          上述信息仅用于页面浏览、安全校验与故障排查，不用于其他目的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          此外，为确保您设备操作环境的安全以及提供我们的产品与服务所必需，防止恶意程序和反作弊，
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          我们会在您同意本《一部手机管旅游隐私政策》后获取您设备上已安装或正在运行的必要的应用安装列表信息及来源
        </span>
        <span style="font-family:'微软雅黑'">
          。请您知悉，单独的应用或应用安装列表信息无法识别您的特定身份，我们仅将其用于安全风控，不会用于其他用途。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.7附加服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可以选择是否授权我们收集和使用您的个人信息的情形如下：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          (1)基于设备信息的附加服务
        </span>
        <span style="font-family:'微软雅黑'">
          ：一部手机管旅游平台的服务需要基于您的电话信息提供，用于读取设备硬件信息，校验IMEI，防止账户被盗，提高登录安全性。若您拒绝授权，您将无法体验上述服务，但不影响您使用其他功能与服务。您可以通过拒绝授权，停止对您的电话信息的获取。我们将通过此服务来为您提供首页功能及一码通服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          (2)基于
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          的附加服务
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ：
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          一部手机管旅游平台的“购物店标记”服务需要基于您的位置信息提供，用于管理部门用户录入购物店时获取购物店位置信息，若您开启设备的地理位置信息收集授权，将会收集您的位置信息，向您提供以上服务。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          若您拒绝授权，您将无法体验上述服务，但不影响您使用其他功能与服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          (3)基于相机/摄像头的附加服务
        </span>
        <span style="font-family:'微软雅黑'">
          ：您可在开启
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          相机/摄像头权限
        </span>
        <span style="font-family:'微软雅黑'">
          后使用该功能进行
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          扫一扫、拍摄照片或视频
        </span>
        <span style="font-family:'微软雅黑'">
          ，在投诉、退货、诚信、考核、导游、旅行社、团队监管、购物店标记、意见反馈、沟通场景中拍摄照片及视频凭证。若您拒绝授权，您将无法体验上述服务，但不影响您使用其他功能与服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          (4)基于存储（相册）的图片/视频访问及上传的附加服务
        </span>
        <span style="font-family:'微软雅黑'">
          ：您可在开启
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          相册权限
        </span>
        <span style="font-family:'微软雅黑'">
          后使用该功能上传投诉、退货、诚信、考核、导游、旅行社、团队监管、购物店标记、意见反馈、沟通场景中所需图片、视频和文件，以及保存图片、视频及文件到系统中，以实现工作存证、与游客或工作人员沟通。若您拒绝授权，您将无法体验上述服务，但不影响您使用其他功能与服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          (5)基于麦克风的语音技术的附加服务
        </span>
        <span style="font-family:'微软雅黑'">
          ：您可在开启
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          麦克风权限
        </span>
        <span style="font-family:'微软雅黑'">
          后使用麦克风实现与游客或工作人员联系。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击一部手机管旅游平台内麦克风图标或录制视频时通过麦克风获取语音信息。若您拒绝授权，您将无法体验上述服务，但不影响您使用其他功能与服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          您理解并同意，上述附加服务可能需要您在您的设备中开启您的设备信息、
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置信息（地理位置）
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          、摄像头（相机）、存储（相册）、麦克风（语音）的访问权限
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          请您注意，您开启任一权限即代表您授权我们可以收集和使用相应个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相应个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          若您提供的信息中含有其他用户的个人信息，在向一部手机管旅游平台提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策公示的途径联系我们，要求更正或删除涉及儿童个人信息的内容。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，若第三方有违法行为的，我们会明确要求对方承担相应法律责任。同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制等）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4
        </span>
        <span style="font-family:'微软雅黑'">
          .根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.1
        </span>
        <span style="font-family:'微软雅黑'">
          与国家安全、公共安全、公共卫生、重大公共利益相关；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.2
        </span>
        <span style="font-family:'微软雅黑'">
          刑事侦查、起诉、审判、执行相关；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.3
        </span>
        <span style="font-family:'微软雅黑'">
          维护生命财产重大权益且难以取得同意；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.4
        </span>
        <span style="font-family:'微软雅黑'">
          个人信息自行公开或从合法公开渠道获取；
        </span>
      </p>
      <p style="margin-top:0pt; margin-bottom:0pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.5
        </span>
        <span style="font-family:'微软雅黑'">
          履行法定义务、维护服务安全稳定必需。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善一部手机管旅游平台的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务，则此类处理后数据的使用无需另行向您通知并征得您的同意。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          5
        </span>
        <span style="font-family:'微软雅黑'">
          .如我们停止运营一部手机管旅游平台产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6
        </span>
        <span style="font-family:'微软雅黑'">
          .在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          7
        </span>
        <span style="font-family:'微软雅黑'">
          .设备权限调用说明
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为确保相关业务功能的正常实现，我们需要根据具体的使用场景调用对应的必要权限，并在调用前向您弹窗询问，具体的权限调用说明如下：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          iOS设备权限调用设备权限：
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：用于向用户提供购物店位置信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：用户使用“购物店标记”更新购物店位置时询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭：
        </span>
        <span style="font-family:'微软雅黑'">
          是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限：
        </span>
        <span style="font-family:'微软雅黑'">
          IDFA（iOS14及以上）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          用于统计和内容服务
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：
        </span>
        <span style="font-family:'微软雅黑'">
          首次打开客户端时弹窗询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭：
        </span>
        <span style="font-family:'微软雅黑'">
          是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限：
        </span>
        <span style="font-family:'微软雅黑'">
          相机
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          用于扫码、拍照、上传图片
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：
        </span>
        <span style="font-family:'微软雅黑'">
          用户主动拍照、扫码、上传图片时询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭：
        </span>
        <span style="font-family:'微软雅黑'">
          是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p
        style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限：
        </span>
        <span style="font-family:'微软雅黑'; background-color:#ffffff">
          照片
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          用于写入和读取用户相册信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：
        </span>
        <span style="font-family:'微软雅黑'">
          用户主动上传、保存图片前询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭：
        </span>
        <span style="font-family:'微软雅黑'">
          是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限：
        </span>
        <span style="font-family:'微软雅黑'">
          麦克风
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：
        </span>
        <span style="font-family:'微软雅黑'">
          用于发送语音信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：
        </span>
        <span style="font-family:'微软雅黑'">
          用户发起语音输入前询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭：
        </span>
        <span style="font-family:'微软雅黑'">
          是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:14pt">
        <span style="font-family:'微软雅黑'; font-size:12pt; font-weight:bold">
          Android设备权限调用设备权限
        </span>
        <span style="font-family:'微软雅黑'; font-size:12pt">
          ：
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold; text-decoration:underline">
          位置
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的：用于向用户提供购物店位置信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问：用户使用“购物店标记”更新购物店位置时询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭
        </span>
        <span style="font-family:'微软雅黑'">
          ：是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限
        </span>
        <span style="font-family:'微软雅黑'">
          ：电话状态
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：用于读取设备硬件信息，校验IMEI，防止账户被盗，提高登录安全性
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问
        </span>
        <span style="font-family:'微软雅黑'">
          ：首次打开客户端时弹窗询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭
        </span>
        <span style="font-family:'微软雅黑'">
          ：是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限
        </span>
        <span style="font-family:'微软雅黑'">
          ：相机
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：用于扫码、拍照、上传图片
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问
        </span>
        <span style="font-family:'微软雅黑'">
          ：用户主动拍照、扫码、上传图片时询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭
        </span>
        <span style="font-family:'微软雅黑'">
          ：是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限
        </span>
        <span style="font-family:'微软雅黑'">
          ：存储
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：用于写入和读取用户相册信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问
        </span>
        <span style="font-family:'微软雅黑'">
          ：用户主动上传、保存图片前询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭
        </span>
        <span style="font-family:'微软雅黑'">
          ：是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          设备权限
        </span>
        <span style="font-family:'微软雅黑'">
          ：麦克风
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          使用目的
        </span>
        <span style="font-family:'微软雅黑'">
          ：用于发送语音信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否询问
        </span>
        <span style="font-family:'微软雅黑'">
          ：用户发起语音输入前询问
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          是否可以关闭
        </span>
        <span style="font-family:'微软雅黑'">
          ：是
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可以在设备的设置中选择关闭部分或者全部权限，这可能导致对应的业务功能无法实现或者无法达到预期效果。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （二）我们如何使用Cookie
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为确保一部手机管旅游平台正常运转，我们会在您的设备上存储Cookie，通常包含临时的登录凭证以及一些标识字符的本地存储（统称“Cookie”）。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在您使用我们的产品与服务时，我们可能会使用Cookie和同类技术收集您的一些个人信息，包括：您的临时登录凭证、您的临时浏览标识字符，Cookie和同类技术收集该类信息是为了您使用我们的产品与服务的必要、简化您重复操作的步骤（如注册、登录）、保护您的信息和账号安全性、改善我们的产品和服务。我们承诺仅在本政策所述目的范围内使用Cookie和同类技术。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          如果您的浏览器允许，您可以通过您的浏览器的设置以管理、部分或全部拒绝Cookie或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie或同类技术，从而实现我们无法全部或部分追踪您的个人信息。您如需详细了解如何更改浏览器设置，请具体查看您使用的浏览器的相关设置页面。您理解并知悉：我们的部分服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的产品与服务或无法通过我们的产品与服务获得最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （三）我们如何共享、转让、公开披露个人信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.共享，我们不会与其他公司、组织和个人共享您的个人信息，但以下情况除外：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.1在您主动选择情况下共享：您通过购买商品、预订服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息与商家或者相关商品和服务的实际服务提供者共享来实现您向其购买商品或预订服务的需求，并促使其可以完成后续的售后服务。您可以在相关商品和服务的提供者从事经营活动的主页面查询其营业执照登载的信息，以辨别您的交易对象身份。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.2在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.3在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4与授权合作伙伴共享：我们会委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不能将此信息用于任何其他目的。对于涉及儿童个人信息的，我们不允许合作伙伴进行转委托。目前，我们的授权合作伙伴包括以下类型：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4.1广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。我们会委托这些合作伙伴与处理广告覆盖面和有效性相关的信息，而不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4.2供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4.3第三方SDK类服务商。我们产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴对其约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们向第三方共享个人信息的情况详见《一部手机管旅游APP第三方信息共享清单》。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.转让，我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.2在发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.公开披露，我们仅会在以下情况下，公开披露您的个人信息：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.1获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.2如果我们确定您出现违反法律法规或严重违反一部手机管旅游平台相关协议规则的情况，或为保护我们及我们关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或一部手机管旅游平台相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我们已对您采取的措施。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.共享、转让、公开披露个人信息时事先征得授权同意的例外，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.1与国家安全、国防安全有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.2与公共安全、公共卫生、重大公共利益有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.3与犯罪侦查、起诉、审判和判决执行等有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.5您自行向社会公众公开的个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （四）我们如何保护个人信息安全
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的一部手机管旅游平台与服务器之间交换数据时受SSL协议加密保护。我们同时对一部手机管旅游平台提供HTTPS协议安全浏览方式。我们会使用加密技术提高个人信息的安全性。我们会使用受信赖的保护机制防止个人信息遭到恶意攻击。我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们设置了儿童信息的保护，严格设定信息访问权限，对可能接触到儿童信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过网络安全等级保护的三级测评和ISO27001认证。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.1完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.2保证我们为您提供服务的安全和质量。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.3您是否同意更长的留存期间。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.4是否存在保留期限的其他特别约定。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.互联网并非绝对安全的环境，我们强烈建议您不要使用非推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          在使用服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如出行人姓名、联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户发生泄漏，请您立即联络客服，以便我们根据您的申请采取相应措施。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          5.我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过公告方式获得。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、消息通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们已制定儿童信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施等。我们将及时将事件相关情况以一部手机管旅游平台消息通知、发送邮件/短消息等方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （五）您如何管理您的个人信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.您有权查询、更正或补充您的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可以登录手机客户端，进入“我的”后，对您的姓名、所属机构、电话号码、签名进行查询，点击头像对您的姓名、手机号、签名、账号权限信息进行查询，对手机号进行更正，对签名进行更正或删除。您还可以通过“我的-设置-账号设置”，对您的手机号、登录密码进行更正。对于姓名、用户部门等不可自行修改的信息，您可通过本政策文末的方式联系我们，一般情况下我们会核实您的身份信息并在15个工作日内回复处理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.删除您的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1您可以通过“您有权查询、更正或补充您的信息”中列明的方式删除您的“签名”信息。在以下情形中，您可以向我们提出删除个人信息的请求：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1.1如果我们处理个人信息的行为违反法律法规。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1.2如果我们收集、使用您的个人信息，却未征得您的明确同意。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1.3如果我们处理个人信息的行为严重违反了与您的约定。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1.4如果您不再使用我们的产品或服务，或您主动注销了账号。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1.5如果我们永久不再为您提供产品或服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.2若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.3当您或我们协助您删除相关信息后，因为适用的法律要求或安全技术原因，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直至备份更新时可以清除这些信息或实现匿名。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.个人信息副本获取权
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          如您需要您的个人信息的副本，您可以通过本政策文末提供的方式联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4．改变或撤回您授权同意的范围
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.1您可以通过删除您的个人信息、关闭设备功能、注销账户的方式改变您授权我们继续收集个人信息的范围或撤回您的授权。通过关闭设备功能来实现改变或撤回授权的路径为“一部手机管旅游APP-我的-设置-系统权限管理”
        </span>
        <span style="font-family:'微软雅黑'">
          ；
        </span>
        <span style="font-family:'微软雅黑'">
          通过注销来实现撤回授权的路径为“我的-设置-
        </span>
        <span style="font-family:'微软雅黑'">
          账号注销
        </span>
        <span style="font-family:'微软雅黑'">
          ”。但请注意，每个业务功能需要一些基本的个人信息才能得以完成（见本政策第二部分（一）我们如何收集和使用您的信息）。如果您改变或撤回对这部分使用目的的全部或部分授权，您可能无法使用特定的业务功能或者无法获得特定业务功能的最佳体验。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.2对于我们持续使用您的个人信息的数据处理行为，当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          5.注销您的账户
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可以随时注销您在一部手机管旅游平台的账户，一部手机管旅游App中的注销路径为“我的-设置-
        </span>
        <span style="font-family:'微软雅黑'">
          账号注销
        </span>
        <span style="font-family:'微软雅黑'">
          ”。在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.响应您的上述请求
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.1为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15天内作出答复。如您不满意，还可以发起投诉。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.2对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些与您的身份不直接关联、无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3
        </span>
        <span style="font-family:'微软雅黑'">
          在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.1与国家安全、国防安全有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.2与公共安全、公共卫生、重大公共利益有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.3与犯罪侦查、起诉、审判和执行判决等有关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.4有充分证据表明个人信息主体存在主观恶意或滥用权利的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.5响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.6涉及商业秘密的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          6.3.7与履行法律法规规定的义务相关的。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （六）我们如何处理未成年人的信息
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.基本原则
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          “一部手机管旅游”平台不面向
        </span>
        <span style="font-family:'微软雅黑'">
          14周岁以下
        </span>
        <span style="font-family:'微软雅黑'">
          未成年人开放。
        </span>
        <span style="font-family:'微软雅黑'">
          不允许
        </span>
        <span style="font-family:'微软雅黑'">
          未成年人注册
        </span>
        <span style="font-family:'微软雅黑'">
          、
        </span>
        <span style="font-family:'微软雅黑'">
          使用、提交
        </span>
        <span style="font-family:'微软雅黑'">
          信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.儿童信息保护规则
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.1
        </span>
        <span style="font-family:'微软雅黑'">
          不主动收集：我们不会主动收集儿童的个人信息。平台
        </span>
        <span style="font-family:'微软雅黑'">
          无主动注册功能，
        </span>
        <span style="font-family:'微软雅黑'">
          不向儿童开放账户注册及信息提交入口。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.2
        </span>
        <span style="font-family:'微软雅黑'">
          身份识别与拦截：若通过实人认证（如身份证号校验等）或其他方式识别出用户为儿童，
        </span>
        <span style="font-family:'微软雅黑'">
          我们
        </span>
        <span style="font-family:'微软雅黑'">
          将拒绝其注册申请，并提示该平台不面向未成年人提供服务。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.3
        </span>
        <span style="font-family:'微软雅黑'">
          误操作处理：如儿童在监护人不知情的情况下误操作提交了个人信息，一经发现，我们将在第一时间予以删除，且不作留存或用于任何其他用途。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.4
        </span>
        <span style="font-family:'微软雅黑'">
          监护人责任提示：我们建议监护人加强对未成年人使用电子设备的监管，引导儿童避免向不面向其开放的平台提供个人信息。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.未成年人误操作处理机制
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          如监护人发现未成年人未经同意在本平台提交了个人信息，可通过本政策
        </span>
        <span style="font-family:'微软雅黑'">
          文末
        </span>
        <span style="font-family:'微软雅黑'">
          提供的联系方式联系我们，我们在核实监护人身份后，将立即删除相关未成年人的全部个人信息，并关闭可能的账户注册尝试。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.特别声明
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          本平台所有功能均面向旅游行业监管工作人员及涉旅企业人员，不涉及面向未成年人的服务场景。如后续业务调整涉及未成年人信息处理，我们将另行制定专门的儿童隐私保护规则，并依法征得监护人同意。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （七）“双清单”展示
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （满足工信部292号文、T/TAF 212/211）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          为保障您的知情权，我们已在一部手机管旅游平台建立并展示以下清单：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.个人信息收集清单
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可通过“我的-设置-隐私说明-个人信息收集清单”路径，查看我们收集您个人信息的具体情况。该清单将根据个人信息处理范围及方式的变化及时更新。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.第三方个人信息共享清单
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          您可通过“我的-设置-隐私说明-第三方信息共享清单”路径，查看第三方应用在您使用本平台过程中收集您个人信息的相关情况。该清单也将根据共享范围及合作方的变动及时更新。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          八
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          ）
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          从中国大陆地区以外访问一部手机管旅游平台
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          一部手机管旅游平台的所有信息及数据均在中国大陆进行处理和存储。如果您从中国大陆以外地区访问一部手机管旅游平台，请您注意，您的信息可能被传送至、存储于中国大陆，并且在中国大陆进行处理。中国大陆的数据保护法和其他法律可能与您所在国家/地区的法律不同，但请相信我们将采取措施保护您的信息。选择使用我们的服务的同时，您了解并同意您的信息可能被传送至我们的平台以及本隐私政策所述的与我们共享信息的第三方。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          九
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          ）本政策如何更新
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.我们的隐私政策可能变更，我们会标注新版本的生效日期。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.未经您明确同意，我们不会限制您按照本政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何变更。对于重大变更，我们会提供更为显著的通知（包括我们会通过公示的方式进行通知甚至向您提供弹窗提示）。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.本政策所指的重大变更包括但不限于：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.1我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.2我们在控制权等方面发生重大变化。如并购重组等引起的所有者变更等。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.3个人信息共享、转让或公开披露的主要对象发生变化。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.4您参与个人信息处理方面的权利及其行使方式发生重大变化。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.5我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          3.6个人信息安全影响评估报告表明存在高风险时。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          4.我们还会将本政策的旧版本存档，您可通过本政策公示的联系方式与我们取得联系查阅旧版本隐私政策。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'; font-weight:bold">
          （
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          十
        </span>
        <span style="font-family:'微软雅黑'; font-weight:bold">
          ）如何联系我们
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.如您有任何与个人信息保护或隐私保护相关的问题、投诉、意见或建议，可以通过以下方式联系我们（云南腾云信息产业有限公司）：
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.1联系客服电话：
        </span>
        <span style="font-family:'微软雅黑'; font-size:11pt">
          0871-68011179
        </span>
        <span style="font-family:'微软雅黑'; font-size:11pt">
          （工作日 9:00-18:00）
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.2联系客服邮箱：service@yntengyun.com；
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.3邮寄至以下地址：云南省昆明市西山区环城南路777号昆钢科技大厦6F；
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          1.4联系腾云个人信息保护专员：kevinliu（邮箱：kevinliu@yntengyun.com）。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          2.一般情况下，我们将在15日内回复。如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您可以向当地的网信管理部门、消费者保护协会投诉，或者您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <p style="margin-top:14pt; margin-bottom:14pt; line-height:150%; font-size:12pt">
        <span style="font-family:'微软雅黑'">
          &#xa0;
        </span>
      </p>
      <div style="-aw-headerfooter-type:footer-primary">
        <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:9pt">
          <span style="height:0pt; display:block; position:absolute; z-index:-65536">
            <img src="a0t7t-232im.001.png" width="97" height="18" alt=""
              style="margin-left:171.4pt; -aw-left-pos:0pt; -aw-rel-hpos:margin; -aw-rel-vpos:paragraph; -aw-top-pos:0pt; -aw-wrap-type:none; position:absolute" />
          </span>
          <span style="font-family:'等线'">
            &#xa0;
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      authData: {}
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
    document.title = '隐私政策';
  },

  created() { },
  beforeCreate() {
    document.title = '隐私政策';
  }
};
</script>

<style scoped lang="less">
.agreement-contain {
  padding: 16px;
  word-break: break-all;

  a {
    color: blue;
  }

  p {
    line-height: 1.5;
  }
}
</style>
